import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AllItems from "./AllItems";

export default function AddStandardItemPopup(props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        disableElevation
        startIcon={<AddIcon />}
        variant={props.idx === 0 ? "contained" : "outlined"}
        color={"primary"}
        onClick={() => {
          setOpen(true);
        }}
        fullWidth
        sx={{ minWidth: 0 }}
      >
        STANDARD ITEM
      </Button>
      {open && (
        <Dialog fullScreen={true} open={open} scroll="paper">
          <DialogTitle
            sx={{
              display: "flex",
              gap: "10px",
              justifyContent: "space-between",
              alignItems: "center",
              margin: "0",
              backgroundColor: "#DEDEDE",
              borderBottom: "3px solid #DEDEDE",
            }}
          >
            <IconButton onClick={() => setOpen(false)}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h5">Pick an Item</Typography>
            <Box></Box>
          </DialogTitle>
          <DialogContent sx={{ backgroundColor: "#F7F7F7" }}>
            <Box py={2}>
              <AllItems
                includeCustom={false}
                onChange={(item) => {
                  props.onChange(item);
                  setOpen(false);
                }}
              />
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
